import { AuthN, getConfig } from '@seek/online-identity';

let authN: AuthN;

export const getAuthN = (): AuthN => {
  if (!authN) {
    const clientConfig = getConfig('seekAnz-hirer', window.location);

    authN = new AuthN(clientConfig);
  }

  return authN;
};
